// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import React from 'react'
import ReactDOM from 'react-dom'
import {QueryClient, QueryClientProvider} from 'react-query'
import {AuthProvider, setupAxios} from './app/pages/landing/auth'
import {AppRoutes} from './app/routing/AppRoutes'
import './_metronic/assets/sass/style.react.scss'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
// react multi carasoul css
import 'react-multi-carousel/lib/styles.css';

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

Chart.register(...registerables)

const queryClient = new QueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <MetronicI18nProvider selectedLang={'en'}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </MetronicI18nProvider>
  </QueryClientProvider>,

  document.getElementById('root')
)
